import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    CmpsCardComponentModule,
    CmpsCardHeaderRowComponentModule,
    CmpsScorecardBonusModule,
    CmpsScorecardCategoryModule,
    CmpsScorecardRankModule,
    CmpsScoreCardScoreSectionModule,
    CmpsScorecardSubHeaderModule,
} from '@cmps/ng-kit';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { mdiLaunch } from '@mdi/js';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { ScorecardService } from '../scorecard/core/scorecard.service';
import { CmpsScorecardModule } from '../scorecard/scorecard.module';
import { CmpsWidgetModule } from '../widget/widget.module';

import { ScorecardScoreContainerComponent } from './components/score-score-container/score-card-score-container.component';
import { ScoreTrendSectionComponent } from './components/score-trend-section/score-trend-section.component';
import { MyScorecardComponent } from './my-scorecard.component';
import { TranslationIdMap } from './my-scorecard.i18n';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsCardHeaderRowComponentModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsWidgetModule,
        CmpsScorecardSubHeaderModule,
        CmpsScorecardRankModule,
        CmpsScorecardBonusModule,
        CmpsScorecardCategoryModule,
        CmpsScoreCardScoreSectionModule,
        BrowserAnimationsModule,
        CmpsIconModule,
        CmpsScorecardModule,
        CmpsButtonModule,
        CmpsTooltipModule,
    ],
    declarations: [
        MyScorecardComponent,
        ScorecardScoreContainerComponent,
        ScoreTrendSectionComponent,
    ],
    exports: [MyScorecardComponent],
    providers: [ScorecardService],
})
export class CmpsMyScorecardModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [['launch', mdiLaunch]].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
